import React, { useState } from "react";
import { Button, ButtonToolbar, Modal } from "rsuite";
import ModalFooter from "rsuite/esm/Modal/ModalFooter";
import { AccountsVM } from "../../../Models/ViewModels";
import { BootstrapIcon } from "../../../SharedComponents/BootstrapIcon";
import { AddEditDeleteAccount } from "./AddEditDeleteAccount";
type attributes = {
  action: string;
  data: AccountsVM;
  onAction: any;
  cachedData: any;
};
export const AccountModal = (props: attributes) => {
  const [open, setOpen] = useState(false);
  const [size, setSize] = useState();
  const handleOpen = (value: any) => {
    setSize(value);
    setOpen(true);
  };
  const handleClose = () => setOpen(false);

  const onAddAccount = (accDetail: AccountsVM) => {
    handleClose();
    props.onAction(accDetail);
  };
  const onEditAccount = (accDetail: AccountsVM) => {
    handleClose();
    props.onAction(accDetail);
  };
  const onDeleteAccount = (accDetail: AccountsVM) => {
    handleClose();
    props.onAction(accDetail);
  };

  if (props.action === "edit") {
    return (
      <div className="modal-container">
        <i
          className="bi bi-pencil-fill text-warning"
          onClick={() => handleOpen("xs")}
        ></i>
        <Modal size={size} open={open} onClose={handleClose}>
          <AddEditDeleteAccount
            title="Edit Account"
            type={props.action}
            data={props.data}
            cachedData={props.cachedData}
            onAction={onEditAccount}
          />
        </Modal>
      </div>
    );
  } else if (props.action === "add") {
    return (
      <div className="modal-container">
        <ButtonToolbar>
          <Button
            appearance="primary"
            color="green"
            size="md"
            onClick={() => handleOpen("xs")}
          >
            <BootstrapIcon
              bootStrapIconName="plus"
              size={15}
              cssClasses="me-1"
            />
            Add
          </Button>
        </ButtonToolbar>

        <Modal size={size} open={open} onClose={handleClose}>
          <AddEditDeleteAccount
            type="add"
            title="Add New Account"
            data={props.data}
            cachedData={props.cachedData}
            onAction={onAddAccount}
          />
          <ModalFooter></ModalFooter>
        </Modal>
      </div>
    );
  } else {
    return (
      <div className="modal-container">
        <ButtonToolbar>
          <i
            className="bi bi-trash3-fill text-danger"
            onClick={() => handleOpen("xs")}
          ></i>
        </ButtonToolbar>
        <Modal size={size} open={open} onClose={handleClose}>
          <AddEditDeleteAccount
            title="Delete Account"
            type={props.action}
            data={props.data}
            cachedData={props.cachedData}
            onAction={onDeleteAccount}
          />
        </Modal>
      </div>
    );
  }
};
